import Vue from 'vue';
import moment from 'vue-moment';
import TableView from '@/components/TableView.vue';
import gettext from '@/plugins/vue-gettext';
import router from '@/router';
import store from '@/store';
import validator from '@/plugins/vee-validate';
import vuetify from '@/plugins/vuetify';
import mixins from '@/plugins/mixins';
import filters from '@/plugins/filters';
import App from './App.vue';
import svgSymbolSpriteLoader from 'svg-symbol-sprite-loader';
import SvgSprite from '@/components/SvgSprite.vue';
import PosCheckbox from '@/components/PosCheckbox.vue';
import PosRadioGroup from '@/components/PosRadioGroup.vue';
import PosDatetimePicker from '@/components/PosDatetimePicker.vue';
import PosDatePicker from '@/components/PosDatePicker.vue';
import PosDobPicker from '@/components/PosDobPicker.vue';
import PosTimePicker from '@/components/PosTimePicker.vue';
import PosCombobox from '@/components/PosCombobox.vue';
import PosSelect from '@/components/PosSelect.vue';
import PosForm from '@/components/PosForm.vue';
import PosJsonExcel from '@/components/PosJsonExcel.vue';
import PosSelectList from '@/components/PosSelectList.vue';
import PosCropImageUpload from '@/components/PosCropImageUpload.vue';
import VueCroppie from "vue-croppie";
import "croppie/croppie.css";

Vue.prototype.store = store;

svgSymbolSpriteLoader({ useCache: process.env.NODE_ENV === 'production' });

/* Plugins */
Vue.use(moment);
Vue.use(VueCroppie);

/* Components */
Vue.component('table-view', TableView);
Vue.component('icon', SvgSprite);
Vue.component('pos-checkbox', PosCheckbox);
Vue.component('pos-radio-group', PosRadioGroup);
Vue.component('pos-datetime-picker', PosDatetimePicker);
Vue.component('pos-date-picker', PosDatePicker);
Vue.component('pos-dob-picker', PosDobPicker);
Vue.component('pos-time-picker', PosTimePicker);
Vue.component('pos-combobox', PosCombobox);
Vue.component('pos-select', PosSelect);
Vue.component('pos-form', PosForm);
Vue.component('pos-json-excel', PosJsonExcel);
Vue.component('pos-select-list', PosSelectList);
Vue.component('pos-crop-image-upload', PosCropImageUpload);

new Vue({
  gettext,
  router,
  store,
  moment,
  validator,
  vuetify,
  render: h => h(App),
}).$mount('#app');
